import { setupReceiptSessionInvalidationListener } from 'app-components/store/listeners';

import { receiptUploadCoordinator } from 'containers/ReceiptCenter/receiptUploadCoordinator';

import { startAppListening } from '../listenerMiddleware';

setupReceiptSessionInvalidationListener(startAppListening, () => receiptUploadCoordinator.invalidate());
